export default __webpack_public_path__ + "static/media/Series-7000-Insertion.c09af399.png";